const data = {
  linkSent: 'linkSent',
  error: 'error',
}
export default data
